import adminapi from './axios.v2.withoutTransform'

const contactUs = obj => adminapi('contact/submit', 'POST', obj, false)

export default { contactUs }
